import React from 'react';
import './MessageInput.css';

const MessageInput = ({ value, onChange, onSend, onKeyPress }) => {
  return (
    <div className="message-input-container">
      <div className="message-input-wrapper">
        <input
          type="text"
          className="message-input"
          placeholder="Type here"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={onKeyPress}
        />
        <button 
          className="send-button"
          onClick={onSend}
          disabled={!value.trim()}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MessageInput;


